import { render, staticRenderFns } from "./Situation.vue?vue&type=template&id=2b3e3f6e&scoped=true"
import script from "./Situation.vue?vue&type=script&lang=js"
export * from "./Situation.vue?vue&type=script&lang=js"
import style0 from "./Situation.vue?vue&type=style&index=0&id=2b3e3f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e3f6e",
  null
  
)

export default component.exports